import { Project } from "@brg/api";
import { FC, useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useRouteMatch } from "react-router-dom";
import { FloatingPager } from "_deziiign/books/core/components/chaptersNavigation/floatingPager/FloatingPager";
import { CreateLinkTo } from "shared/constants/linkTo";
import { useProjectsList } from "shared/hooks/api/useProjectsByFilter";

export enum Position {
    top = 'top',
    bottom = 'bottom'
}

interface ChaptersNavigationProps {
    currentChapter: Project;
    position: Position;
}

export const ChaptersNavigation: FC<ChaptersNavigationProps> = ({
    currentChapter,
    position
}) => {
    const { i18n } = useTranslation();
    const history = useHistory();
    const isBookPreview = !!useRouteMatch(['/book-preview', '/books/preview/']);
    const isPreview = !!useRouteMatch(['/preview']);
    

    const chaptersFilter = useMemo(() => ({
        projectFilter: 8,
        isLite: true,
        bookId: currentChapter.bookId,
        isContextIgnored: true
    }), [currentChapter]);

    const [chapters] = useProjectsList(chaptersFilter, i18n.language);

    const onChapterClick = useCallback(
      (chapterId: string): void => {
        history.push(
          isBookPreview
            ? CreateLinkTo.bookProjectPreview(chapterId)
            : isPreview
              ? CreateLinkTo.preview(chapterId)
              : CreateLinkTo.bookProject(chapterId)
        );
      },
      [history]
    );

    if (!chapters || chapters.data.length === 0) {
        return null;
    }

    return (
        <FloatingPager
            currentIdentifier={currentChapter.projectId}
            identifiers={chapters.data.map(x => x.projectId)}
            onClick={onChapterClick}
            position={position}
        />
    );
}import { Project } from "@brg/api";
import { FC, useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useRouteMatch } from "react-router-dom";
import { FloatingPager } from "_deziiign/books/core/components/chaptersNavigation/floatingPager/FloatingPager";
import { CreateLinkTo } from "shared/constants/linkTo";
import { useProjectsList } from "shared/hooks/api/useProjectsByFilter";

export enum Position {
    top = 'top',
    bottom = 'bottom'
}

interface ChaptersNavigationProps {
    currentChapter: Project;
    position: Position;
}

export const ChaptersNavigation: FC<ChaptersNavigationProps> = ({
    currentChapter,
    position
}) => {
    const { i18n } = useTranslation();
    const history = useHistory();
    const isBookPreview = !!useRouteMatch(['/book-preview', '/books/preview/']);
    const isPreview = !!useRouteMatch(['/preview']);
    

    const chaptersFilter = useMemo(() => ({
        projectFilter: 8,
        isLite: true,
        bookId: currentChapter.bookId,
        isContextIgnored: true
    }), [currentChapter]);

    const [chapters] = useProjectsList(chaptersFilter, i18n.language);

    const onChapterClick = useCallback(
      (chapterId: string): void => {
        history.push(
          isBookPreview
            ? CreateLinkTo.bookProjectPreview(chapterId)
            : isPreview
              ? CreateLinkTo.preview(chapterId)
              : CreateLinkTo.bookProject(chapterId)
        );
      },
      [history]
    );

    if (!chapters || chapters.data.length === 0) {
        return null;
    }

    return (
        <FloatingPager
            currentIdentifier={currentChapter.projectId}
            identifiers={chapters.data.map(x => x.projectId)}
            onClick={onChapterClick}
            position={position}
        />
    );
}